<template>
  <div class="product">
    <div class="listPreview">
      <div class="setMode withSelect">
        <span class="innerTitle setLabel">{{locale.edit_mode}}</span>
        <select class="input inlineInput" @change="setPreviewMode">
          <option value="mobile" :selected="previewMode === 'mobile'">{{locale.mobile}}</option>
          <option value="tablet" :selected="previewMode === 'tablet'">{{locale.tablet}}</option>
        </select>
      </div>
      <p class="cnt"><span class="colorPrimary f_medium">{{filteredList.length}}</span> <span class="colorGrey"> / {{list.length}}</span></p>
    </div>
    <div class="productList" :data-preview="prevMode">
      <button
        type="button"
        class="productItem addItem"
        @click="addItem">
        +
      </button>
      <Item
        v-for="(item, index) in filteredList"
        :key="item.id"
        :locale="locale"
        :lang="lang"
        :item="item"
        :length="list.length"
        :zIndex="list.length - index"
        :productInfo="productInfo"
        :category="category"
        :itemByCategory="itemByCategory"
        :productList="list"
        :hasGuestType="hasGuestType"
        :submitCategory="submitCategory"
        :pIdType="pIdType"
        :requiredSubmitCategory="requiredSubmitCategory"
        :requiredPidType="requiredPidType"
        :ratio="ratio"
        :prevMode="prevMode"
        @setLink="setLink"
        @updateInfo="updateItemInfo"
        @updateManage="updateItemManage"
        @delManageInfo="delManageInfo"
        @copy="copyItem"
        @delete="deleteItem"
        @save="saveItem" />
      <!-- 자세히보기 링크 -->
      <div
        v-if="setLinkLayer"
        class="layer setLinkLayer">
        <div class="inner">
          <button type="button" class="btnClose" @click="setLinkApply(true)"><span class="blind">close</span></button>
          <SetLink
            :link="linkInfo" />
        <!-- <div class="mt15">
          <button type="button" class="btn btnFull btnPrimary" @click="setLinkApply(true)">{{locale.apply}}</button>
        </div> -->
        </div>
      </div>
      <!-- //자세히보기 링크 -->
    </div>
  </div>
</template>

<script>
import DATE from '@/common/date'
import Item from '@/components/Product/Item'
import SetLink from '@/components/Util/SetLink'
import regExp from '@/common/regExp'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'

export default {
  name: 'ProductItemList',
  props: [
    'locale',
    'lang',
    'list',
    'productInfo',
    'category',
    'itemByCategory',
    'hasGuestType',
    'submitCategory',
    'pIdType',
    'requiredSubmitCategory',
    'requiredPidType',
    'ratio',
    'prevMode'
  ],
  components: {
    Item,
    SetLink
  },
  computed: {
    listView () {
      return this.$store.state.product.listView
    },
    getFilter () {
      return this.$store.getters['product/getFilter']
    },
    filteredList () {
      const category = this.getFilter.list
      const word = regExp.replaceAllEmpty(this.getFilter.word)
      const viewOption = this.listView
      // 관리상품 여부 필터
      function listManage (arr) {
        return arr.filter(x => {
          const manageOn = viewOption.manageOn && (x.manage && (x.info.pId === (x.manageInfo && x.manageInfo.pId)))
          const manageOff = viewOption.manageOff && !(x.manage && (x.info.pId === (x.manageInfo && x.manageInfo.pId)))
          return manageOn || manageOff
        })
      }
      // 서비스 상태 필터
      function listService (arr) {
        return arr.filter(x => {
          const serviceOn = viewOption.serviceOn && x.service
          const serviceOff = viewOption.serviceOff && !x.service
          return serviceOn || serviceOff
        })
      }
      // 요청가능 상태 필터
      function listEnabled (arr) {
        return arr.filter(x => {
          const disabled = viewOption.disabled && x.disabled
          const enabled = viewOption.enabled && !x.disabled
          return disabled || enabled
        })
      }
      function listView (arr) {
        return listManage(listEnabled(listService(arr)))
      }
      function findWord (obj, word) {
        let result = 0
        Object.values(obj).forEach(function (x) {
          const val = regExp.replaceAllEmpty(x)
          if (val.length && val.includes(word)) {
            // result.push(x)
            result += 1
          }
        })
        return result > 0
      }
      // 상태 필터 후 전체 리스트 리턴
      let list = this.list ? listView(this.list) : []
      if (word && word.length) {
        /**
         * 검색어는 이름,
         * 상품명(다국어obj),
         * 설명(다국어obj),
         * 상세(다국어obj),
         * 식별코드 대상으로 검색
         */
        list = list.filter(x => {
          const pName = regExp.replaceAllEmpty(x.info.pName)
          const pId = regExp.replaceAllEmpty(x.info.pId)
          const hasName = findWord(x.info.name, word)
          const hasDesc = findWord(x.info.desc, word)
          const hasDetail = findWord(x.info.detail, word)
          return pName.includes(word) || pId.includes(word) || hasName || hasDesc || hasDetail
        })
      }
      // 카테고리
      if (category.length) {
        list = list.filter(x => {
          if (category.length >= 1) {
            return x.category && x.category.length
              ? x.category.filter(c => category.includes(c)).length > 0
              : category.includes('')
          } else { // uncategorized 하나만 있는 경우
            return x.category.length === 0 || x.category.includes('')
          }
        })
      }
      return list
    }
  },
  data () {
    return {
      setLinkLayer: false,
      legacyLinkInfo: {},
      linkInfo: {},
      previewMode: 'mobile'
    }
  },
  methods: {
    addItem () {
      this.$emit('addItem')
    },
    setPreviewMode (e) {
      const value = e.target && e.target.value
      if (value) {
        this.$emit('setPreviewMode', value)
      }
    },
    setLink (item) {
      this.setLinkLayer = true
      this.linkInfo = { ...item.link, id: item.id }
      this.legacyLinkInfo = this._.cloneDeep(item.link)
    },
    setLinkApply (isApply) {
      const itemId = this.linkInfo.id
      const item = this.list.find(x => x.id === itemId)
      if (!isApply) {
        if (window.confirm(this.locale.confirm_cancel)) {
          item.link = this.legacyLinkInfo
          this.setLinkLayer = false
        }
      } else {
        item.link = this.linkInfo
        this.setLinkLayer = false
      }
    },
    updateItemInfo (info) {
      const item = this.list.find(x => x.id === info.id)
      const target = info.target
      const data = info.data
      item.info[target] = data
    },
    updateItemManage (manageInfo) {
      this.$emit('updateItemManage', manageInfo)
    },
    delManageInfo (id) {
      this.$emit('delManageInfo', id)
    },
    copyItem (id) {
      this.$emit('copyItem', id)
    },
    deleteItem (id) {
      this.$emit('delItem', id)
    },
    saveItem () {
      // const data = {
      //   id: this.isNew ? this.moment() : this.id,
      //   items: this.list
      // }
      // this.$store.dispatch('setProductItem', data)
      this.$emit('save', this.list)
    }
  }
}
</script>

<style lang="scss" scoped>
.listPreview {
  display: flex;
  margin-bottom: 15px;
  .cnt {
    margin-left: auto;
  }
}
.productList {
  .addItem {
    height: 202px;
    text-align: center;
    font-size: 4em;
    color: $color-grey;
  }
}
.setLinkLayer .inner {
  max-width: 400px;
}
</style>
